import { checkAvatar } from "@infrastructure/Services/ProfileService";
import { updateUserInBackendFromSso } from "../../Infrastructure/Services/AuthService";

export default function userAvatarChecker(
    src: string | undefined | null,
    userId: string | undefined,
) {
    if (
        src &&
        process.env.REACT_APP_ENV !== "local" &&
        process.env.REACT_APP_ENV !== "checktok.local"
    ) {
        checkAvatar(src).then((res) => {
            if (!res && userId) {
                updateUserInBackendFromSso(userId);
            }
        });
    }
}
